import { t } from '../../../../common/i18n.js'
import { Language } from '../../../../common/types/i18n.js'
import { BalanceTimeAuthStatus } from '../../../../common/types/playtime.js'


export interface BalanceTimeConnectProps {
    authStatus: BalanceTimeAuthStatus
    lang: Language
}


export const BalanceTimeConnect = (props: BalanceTimeConnectProps) => {
    const bt = t.playtime.balancetime
    const { lang } = props

    return (
        <div className="balancetime-auth">
            <div className="balancetime-auth__cards">
                {/* Harvest card */}
                <div
                    className={`balancetime-auth__card ${!props.authStatus.needsHarvest ? 'balancetime-auth__card--connected' : ''}`}
                >
                    <div className="balancetime-auth__card-header">
                        <h3>{bt.harvestIntegration(lang)}</h3>
                    </div>
                    <p className="balancetime-auth__subtitle">{bt.harvestDesc(lang)}</p>
                    <div className="balancetime-auth__card-action">
                        {props.authStatus.needsHarvest ? (
                            <a
                                href={props.authStatus.harvestAuthUrl ?? '#'}
                                className="balancetime-auth__connect-btn"
                            >
                                {bt.connectHarvest(lang)}
                            </a>
                        ) : (
                            <span className="balancetime-auth__status">{bt.connected(lang)}</span>
                        )}
                    </div>
                </div>

            </div>
        </div>
    )
}
